import React from 'react';
import { useHistory } from 'react-router-dom';
import { SIGN_IN_PATH } from '../../routing/paths.constants';
import { ReactComponent as LogoIcon } from '../../../assets/icons/logo.svg';
import './logo-button.less';

interface ILogoButton {
  disabled?: boolean;
}

const LogoButton = ({ disabled }:ILogoButton) : JSX.Element => {
  const { push } = useHistory();
  const onClick = () => {
    push(SIGN_IN_PATH);
  };
  return (
    // eslint-disable-next-line react/jsx-no-bind
    <button type="button" className={`button__logo ${disabled ? 'disabled' : ''}`} onClick={disabled ? undefined : onClick}>
      <LogoIcon />
    </button>
  );
};

export default LogoButton;
